<template>
  <div class="page">
    <div class="logo">
      <img src="@/assets/img/237.png" alt="">
    </div>
    <div class="bigImg">
      <img src="@/assets/img/232.png" alt="">
    </div>
    <div class="content">
      <div class="c-cent">
        <div class="js">优惠套餐介绍</div>
        <div class="js-img">
          <img src="@/assets/img/241.png" alt="">
        </div>
        <div class="js-price">
          <div class="js-flex">
            <div class="js-flex-items-left">9.9<span>元</span></div>
            <div class="js-flex-items-right">100G</div>
          </div>
          <div class="js-flex">
            <div class="js-flex-items-left">19.9<span>元</span></div>
            <div class="js-flex-items-right">200G</div>
          </div>
        </div>
        <div class="js-hd">首次激活套餐支付100元得480元，480元活动余额直接到账。订购套餐，实名认证后，即可畅享网络。 </div>
        <div class="js-sh">*上述活动后期可持续参加</div>
      </div>
      <van-button class="bu_tn" round block type="info" native-type="submit" @click="sureToRecharge()">立即订购</van-button>
    </div>
    <div class="customer" @click="cust">
      <img src="@/assets/23213.png" alt="">
      <div class="zx">在 线 客 服</div>
    </div>

    <div v-html="payUrl"></div>
    <div class="shareit" v-if="is_WeChat">
      <img class="arrow" src="@/assets/img/arrowhead.png" />
      <div class="follow">支付宝支付请右上角点击 在游览器打开 进行支付,<br />支付成功后 请重新扫码登录进行激活操作<br /></div>
    </div>


  </div>
</template>
<script>
import { Dialog } from 'vant'
import { wxRequest } from '@/api/user.js'
export default {
  data() {
    return {

      is_WeChat: false,
      payUrl: '',


      newHome: this.$store.state.newHome,
      newHomes: localStorage.getItem('newHome'),
      input: this.$store.state.recordLoginText,
      isDialogShow: false,
      // 设置密码
      password: '',
      confirmPassword: '',
      alreadySetUp: false,
      showPasswordPanel: false,
      passwordKeyboard: false,
      confirmPasswordKeyboard: false,
      passwordPanelTop: 50,

      // 当前余额套餐
      currentItem: 0,
      price: 0,
      giftBalance: 0,

      // 自定义金额
      popup: false,

      // 自定义键盘
      showKeyboard: false,
      definedPrice: '',

      type: '',
      indexActive: ''
    }
  },
  created() {
    this.is_WeChat = false
    if (this.$route.query.row) {
      this.payUrl = JSON.parse(decodeURIComponent(this.$route.query.row))
      this.$nextTick(() => {
        document.forms[0].submit()
      })
    }
  },

  methods: {




    cust() {
      window.location.href = 'https://kefu.szxxtx.com/s/6953938yd'
    },
    /** *   修改密码     ***/
    passwordOnfocus() {
      this.passwordKeyboard = true
      this.confirmPasswordKeyboard = false
      this.passwordPanelTop = 30
    },
    passwordOnDelete() {
      this.password = this.password.slice(0, this.password.length - 1)
    },

    passwordOnInput(key) {
      this.password = (this.password + key).slice(0, 6)
    },

    confirmPasswordOnfocus() {
      this.passwordKeyboard = false
      this.confirmPasswordKeyboard = true
      this.passwordPanelTop = 30
    },
    confirmPasswordOnDelete() {
      this.confirmPassword = this.confirmPassword.slice(0, this.confirmPassword.length - 1)
    },

    confirmPasswordOnInput(key) {
      this.confirmPassword = (this.confirmPassword + key).slice(0, 6)
    },

    cancelChangePassword() {
      this.password = ''
      this.confirmPassword = ''
      this.passwordPanelTop = 50
      this.showPasswordPanel = false
    },

    checkPassword() {
      if (this.password.length < 6) {
        Dialog.alert({ message: '请设置六位支付密码' })
        return false
      }

      if (this.password != this.confirmPassword) {
        Dialog.alert({ message: '两次输入的新密码不一致' })
        return false
      }
      return true
    },

    /** *   修改密码  end   ***/
    sumbit() {
      this.showPasswordPanel = true
    },
    onBridgeReady(param) {
      const _this = this
      WeixinJSBridge.invoke('getBrandWCPayRequest', param, function (res) {
        if (res.err_msg === 'get_brand_wcpay_request:ok') {
          _this.$router.push({
            path: '/newUser/home',
            query: {
              iccid: _this.$store.state.iccid
            }
          }).catch(() => {

          })
        }
      }
      )
    },
    async sureToRecharge() {
      var params = {
        iccid: this.$store.state.iccid ? this.$store.state.iccid : localStorage.getItem('iccid'),
        amount: 100 * 100, //固定值         
        giftBalance: 0, //固定值 	   
        yucun: 1, //固定值
        payType: 20,// 固定微信支付         

      }
      var postUrl = "order/user/create/priceOrder";
      await wxRequest("sim/pay/type", params, "post").then(res => {
        if (res.data.code == 406) {
          postUrl = "order/user/create/priceOrderHf";
          params.payType = 60;
        } else if (res.data.code == 408) {
          postUrl = "order/ali/user/create/priceOrder";
          params.payType = 80;
        } else if (res.data.code == 409) {
          postUrl = "order/ali/user/create/priceOrder/mi";
          params.payType = 90;
        } else if (res.data.code == 410) {
          postUrl = "order/ali/user/create/priceOrder/dh";
          params.payType = 90;
        } else if (res.data.code == 491) {
          postUrl = "order/ali/user/create/priceOrder/hl";
          params.payType = 90;
        } else if (res.data.code == 492) {
          postUrl = "order/ali/user/create/priceOrder/yy";
          params.payType = 92;
        } else if (res.data.code == 493) {
          postUrl = "order/ali/user/create/priceOrder/long";
          params.payType = 90;
        } else if (res.data.code == 494) {
          postUrl = "order/ali/user/create/priceOrder/huo";
          params.payType = 93;
        } else if (res.data.code == 498) {
          postUrl = "order/ali/user/create/priceOrder/bf";
          params.payType = 98;
        }
      })
      await wxRequest(postUrl, params, "post").then(res => {
        if (res.data.code == 200) {
          if (params.payType == 50) {//乐刷
            window.location.href = res.data.data.jspay_url;
          } else if (params.payType == 92 || params.payType == 93|| params.payType == 98) {
            //云游
            window.location.href = res.data.data;
          } else if (params.payType == 20) {//微信第三方
            var param = res.data.data.param;
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
              } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
              }
            } else {
              this.onBridgeReady(param);
            }

          } else if (params.payType == 90) {//微信第三方
            var param = res.data.data;
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
              } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
              }
            } else {
              this.onBridgeReady(param);
            }

          } else if (params.payType == 60) { //汇付天下
            let datas = JSON.parse(res.data.data);
            if (datas.status === 'succeeded') {
              let payment = datas;
              AdaPay.doPay(payment, (res) => {
                Dialog.alert({ title: '提示', message: res.result_message });
              })
            }
          } else if (params.payType == 80) {
            window.location.href = res.data.data;
          }
        } else {
          Dialog.alert({ message: res.data.message });
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.page {
  padding-top: 28px;
  height: calc(100% - 27px);
  background: #005DF3;

  .logo {
    margin-left: 30px;
    width: 145px;
    height: 28px;

    img {
      width: 100%;
    }
  }

  .bigImg {
    margin-top: 32px;
    margin-left: 32px;
    width: 312px;
    height: 216px;

    img {
      width: 100%;
    }
  }

  .customer {
    position: fixed;
    right: 6px;
    top: 40%;
    width: 40px;
    height: 120px;
    text-align: center;
    color: #3E391F;
    background: #FFEA23;
    border-radius: 20px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    writing-mode: vertical-rl;
    font-family: HarmonyOS_Sans_SC_Medium;

    img {
      width: 22px;
      height: 22px;
      margin-bottom: 6px;
    }
  }

  .content {
    background: url('../../assets/img/236.png') no-repeat top center;
    background-size: 100%;
    padding-bottom: 30px;

    .c-cent {
      // height:368px;
      background: #fff;
      border-radius: 20px;
      width: 88%;
      margin: auto;
      margin-top: 20px;
      position: relative;

      .js {
        position: absolute;
        height: 50px;
        width: 190px;
        top: -25px;
        left: 0;
        right: 0;
        margin: auto;
        background: url('../../assets/img/234.png') no-repeat center;
        background-size: 100%;
        font-size: 22px;
        color: #fff;
        line-height: 50px;
        text-align: center;
      }

      .js-img {
        height: 50px;
        padding-top: 44px;
        width: 296px;
        margin: auto;
        margin-bottom: 16px;

        img {
          width: 100%
        }
      }

      .js-price {
        width: 90%;
        border: 1px solid #005DF3;
        border-radius: 10px;
        background: #E0FEFE;
        margin: auto;
        font-family: HarmonyOS_Sans_SC_Black;

        .js-flex {
          display: flex;
          align-items: flex-end;
          margin: 15px 20px;

          .js-flex-items-left {
            font-size: 44px;
            color: #FF8017;
            font-weight: bold;
            padding-left: 32px;

            span {
              color: #005DF3;
              font-size: 24px;
            }
          }

          .js-flex-items-right {
            margin-left: 22px;
            font-size: 34px;
            color: #005DF3;
            font-weight: bold;
          }

          &:nth-child(1) {
            border-bottom: 1px dashed #95B4B4;
            padding-bottom: 16px;
          }
        }
      }

      .js-hd {
        font-size: 16px;
        color: #555657;
        width: 90%;
        margin: auto;
        margin-top: 11px;
        font-family: PingFangSC-Medium, PingFang SC;
        line-height: 24px;
      }

      .js-sh {
        color: #4C4C4C;
        font-size: 18px;
        padding: 10px 0 16px;
        text-align: center;
        font-weight: 600;
        font-family: HarmonyOS_Sans_SC_Bold;
      }
    }

    .bu_tn {
      width: 86%;
      margin: 18px auto;
      height: 52px;
      border-radius: 24px;
      background: url('../../assets/img/235.png')no-repeat center;
      background-size: 100%;
      border: none;
      font-size: 22px;
      font-family: HarmonyOS_Sans_SC_Bold;
    }
  }
}





.shareit {
  -webkit-user-select: none;
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  top: 0;
  left: 0;
  z-index: 999;
}

.shareit img {
  max-width: 100%;
}

.arrow {
  width: 100px;
  height: 150px;
  position: absolute;
  right: 5%;
  top: 1%;
}

.follow {
  margin-right: 6px;
  margin-left: 30px;
  width: 90%;
  // height: 100rpx;
  line-height: 30px;
  // text-align: left;
  text-decoration: none;
  font-size: 18px;
  color: white;
  float: left;
  margin-top: 180px;
}
</style>
